// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1ReportSchema } from './v1/reportSchema';

export const listPinnedReportsPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
});

export const listPinnedReportsQueryParamsSchema = z.object({
  user_ids: z.optional(z.coerce.string().describe("Comma-separated list of user IDs to filter pinned reports")),
}).optional();

export const listPinnedReportsHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Pinned reports retrieved successfully
 */
export const listPinnedReports200Schema = z.array(z.lazy(() => v1ReportSchema));

export const listPinnedReportsQueryResponseSchema = z.lazy(() => listPinnedReports200Schema);
